import AxiosInstance from "./api";

export const PurchaseOrderService = {
  getPaginate: async (query) => {
    return await AxiosInstance.get("/private/purchase-order", { params: query });
  },
  getById: async (id) => {
    return await AxiosInstance.get(`/private/purchase-order/${id}`);
  },
  create: async (payload) => {
    return await AxiosInstance.post("/private/purchase-order", payload);
  },
  update: async (id, payload) => {
    return await AxiosInstance.patch(`/private/purchase-order/${id}`, payload);
  },
  delete: async (id) => {
    return await AxiosInstance.delete(`/private/purchase-order/${id}`);
  },
};
